module.exports = __webpack_public_path__ + "static/img/wuliuchaxun.3568ae82.png";